import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { useDispatch, useSelector } from 'react-redux';

import { getModalData, isModalActive, closeModal } from "../../store/slices/modal";

import { useGetInstanceStudents } from "../../hooks/students";
import { useCreateExpertConversation } from "../../hooks/users";

import { SVGIcon } from "../wrappers/SVGIcon";

import { IMessageModalData } from "../../interfaces/modals";
import { EExpertConversationStatus, EExpertFrom } from "../../interfaces/expert_chats";

import { Icons } from "../../data/Assets";

const modalName = "NEW_CHAT_MODAL";
const modalTitle = "New Chat";
const modalClass = "new_chat";

ReactModal.setAppElement('#root');
const NewChatModal = () => {
    const dispatch = useDispatch();

    const isModalVisible: boolean = useSelector(isModalActive(modalName));
    const modalData: IMessageModalData | null = useSelector(getModalData(modalName));
    const { closeOnEsc = true, closeOnOutsideClick = true, closeBtn = true } = modalData || {};

    const [selectedStudentId, setSelectedStudentId] = useState<number | null>(null);
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const { data: students } = useGetInstanceStudents();

    const { mutate: createExpertConversation } = useCreateExpertConversation();


    const afterOpenModal = () => { };

    const onCloseModal = () => {
        dispatch(closeModal(modalName));
    };

    const handleSelectStudent = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedStudentId(parseInt(e.target.value));
    };

    const onCreateNewChat = () => {
        const student = students?.find(student => student.id === selectedStudentId);
        if (!student) return;

        createExpertConversation({
            student_id: student.id,
            payload: {
                create_expert_conversation: {
                    title: 'New Conversation',
                    expert_from: EExpertFrom.SCHOOL,
                    status: EExpertConversationStatus.OPEN,
                }
            },
            setIsProcessing: setIsProcessing,
            setErrorMessage: setErrorMessage,
            successCallback: (data) => {
                onCloseModal();
            }
        });
    };

    useEffect(() => {
        if (students && students.length > 0) {
            setSelectedStudentId(students[0].id);
        }
    }, [students]);

    return (
        <ReactModal
            id={modalName}
            isOpen={isModalVisible && !!modalData}
            onAfterOpen={afterOpenModal}
            onRequestClose={onCloseModal}
            contentLabel={modalTitle}
            overlayClassName={`immersion__modal_overlay immersion__modal_overlay__${modalClass}`}
            className={`immersion__modal_dialog immersion__modal_dialog__${modalClass}`}
            shouldCloseOnEsc={closeOnEsc}
            shouldCloseOnOverlayClick={closeOnOutsideClick}
        >
            <div className={`immersion__modal_content immersion__modal_content__${modalClass}`}>
                {closeBtn &&
                    <button className="immersion__modal_close_btn" onClick={onCloseModal}>
                        <SVGIcon src={Icons.X} />
                    </button>
                }
                <div className="immersion__new_chat_modal__view">
                    <h4 className="immersion__color__dark">{modalTitle}</h4>
                    {students &&
                        <select className="immersion__new_chat_modal__select" onChange={handleSelectStudent}>
                            {students.map(student => (
                                <option key={student.id} value={student.id}>{student.first_name} {student.last_name}</option>
                            ))}
                        </select>
                    }
                    <div className="immersion__new_chat_modal__actions">
                        <button className="immersion__btn immersion__btn__secondary" onClick={onCloseModal}>Cancel</button>
                        <button
                            className="immersion__btn immersion__btn__primary"
                            onClick={onCreateNewChat}
                            disabled={isProcessing}
                        >
                            {isProcessing ? <i className="immersion__btn_loader" /> : 'Create Chat'}
                        </button>
                    </div>
                </div>
                {errorMessage && <div className="immersion__new_chat_modal__error">{errorMessage}</div>}
            </div>
        </ReactModal>
    );
};

export default NewChatModal;